function dialogReducer(state, action) {
  switch (action.type) {
    case "TOGGLE": {
      return { ...state, isOpen: !state.isOpen };
    }
    default: {
      throw new Error(`Unhandled action type: ${action.type}`);
    }
  }
}
const dialogInitState = {
  isOpen: false,
};

export { dialogInitState, dialogReducer };
